import Config from '@config';
import { normalizeInfiniteQueryData } from '@gasbi/shared/common/features/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiKey, ApiKeyDetailed } from '@/features/apiKeys/types';
import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import { FiltersGrid, Pagination } from '@/features/types';
import { infiniteQueryOptions } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const apiKeysApi = createApi({
  reducerPath: 'apiKeysApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/apikeys`,
  }),
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  tagTypes: ['ApiKeys', 'ApiKey'],
  endpoints: builder => ({
    // TODO currently it does not needed
    // getApiKeyProjects: builder.query<ReferenceBook[], void>({
    //   query: () => ({
    //     url: `/projects`,
    //   }),
    // }),
    getApiKeys: builder.infiniteQuery<ApiKey, FiltersGrid, Pagination>({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['ApiKeys'],
    }),
    getApiKeyById: builder.query<ApiKeyDetailed, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: () => ['ApiKey'],
    }),
    createApiKey: builder.mutation<
      { id: string; key: string },
      { name: string; expirationDate?: string }
    >({
      query: data => ({
        method: 'POST',
        url: `/`,
        data,
      }),
      invalidatesTags: () => ['ApiKeys'],
    }),
    deactivateApiKey: builder.mutation<void, string>({
      query: id => ({
        method: 'PUT',
        url: `/${id}/deactivate`,
      }),
      invalidatesTags: () => ['ApiKeys', 'ApiKey'],
    }),
  }),
});

export const {
  useGetApiKeyByIdQuery,
  useCreateApiKeyMutation,
  useDeactivateApiKeyMutation,
} = apiKeysApi;

export const useGetApiKeysInfiniteQuery = normalizeInfiniteQueryData(
  apiKeysApi.useGetApiKeysInfiniteQuery,
);
